<template>
    <tr class="TableRow">
        <td class="STProductName">
            <div class="Form">
                <div class="FormRow">
                    <div class="FormBoxWide FormCheckBox">
                        <div class="Label">
                            <span>
                                <i>{{ articolo.DescrizioneArticolo}}</i>
                                <div class="ItemPreview">
                                    <div class="Frame"><i><img :src="this.urlImmagineArticoloFull" alt="" /></i></div>
                                </div>
                            </span>
                        </div>
                        <div class="Field"><a href="javascript:void(0)" @click="this.deleteRowCart()"><img src="/images/QtyClearIcon.png" srcset="/images/QtyClearIconRetina.png 2x" alt=""/></a></div>
                    </div>
                </div>
            </div>
        </td>
        <td class="STProductColor">
            <small>{{ this.risorse["TabVarColore"] }}</small>
            <span>{{articolo.DescrizioneColore}}</span>
        </td>
        <td class="STProductSize">
            <small>{{ this.risorse["TabVarTaglia"] }}</small>
            <span>{{ articolo.DescrizioneTaglia}}</span>
        </td>
        <td class="STProductCode">
            <small>{{ this.risorse["TabVarCodice"] }}</small>
            <span>{{ articolo.CodiceArticolo }}</span>
        </td>
        <td class="STUnitPrice">
            <small>{{ this.risorse["TabVarPrezzoUn"] }}</small>
            <span>
                <div v-if="articolo.PrezzoNetto < articolo.PrezzoListino">
                    <span v-show="articolo.PrezzoAgente > 0">
                        <del>{{this.simboloValuta}} {{ this.formatNumber((articolo.PrezzoListino ), 2, ',', '.') }}</del>
                        <ins>{{this.simboloValuta}} {{ this.formatNumber((articolo.PrezzoNetto ), 2, ',', '.')}}</ins>
                    </span>
                    <div v-if="this.HaScontoLogistico">
                        <a href="javascript:void(0)" @click="this.OpenModal()"><img :class="{NotActive: this.qtaMultiplo }" src="/images/DiscountIconYellow.svg" alt="" /></a>
                    </div>
                </div>
                <div v-else>
                    <span>
                        <ins>{{this.simboloValuta}} {{ this.formatNumber((articolo.PrezzoNetto ), 2, ',', '.')}}</ins>
                    </span>
                    <div v-if="this.HaScontoLogistico">
                        <a href="javascript:void(0)" @click="this.OpenModal()"><img :class="{NotActive: this.qtaMultiplo }" src="/images/DiscountIconYellow.svg" alt="" /></a>
                    </div>
                </div>
            </span>
        </td>
        <td class="STQuantity">
            <div class="TableQtySettingBox Refresh">
                <div class="Form">
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputText">
                            <div class="Field"><input type="text" v-model="this.quantita"/></div>
                        </div>
                    </div>
                </div>
                <div class="TableQtyHandling">
                    <a href="javascript:void(0)" @click="this.addCartRow()"><img src="/images/RefreshWhiteIcon.png" srcset="/images/RefreshWhiteIconRetina.png 2x" alt=""/></a>
                </div>
                <div class="loader loaderCart" v-show="this.isLoading"></div>
            </div>
        </td>
        <td class="STSubtotal">
            <small>{{ this.risorse["TabVarSub"] }}</small>
            <div v-if="!this.qtaMultiplo">
                <span><del>{{ this.simboloValuta }} {{ this.formatNumber(this.getSubTotal(), 2, ',', '.')}}</del></span>
                <span>{{ this.simboloValuta }} {{ this.formatNumber(this.getSubTotalSconto(), 2, ',', '.')}}</span>
            </div>
            <div v-else>
                <span>{{ this.simboloValuta }} {{ this.formatNumber(this.articolo.PrezzoTotale, 2, ',', '.')}}</span>
            </div>
        </td>
    </tr>

    <ModalScontiLogistici
        v-model="this.showModal" 
        :PezziConfezione="this.articolo.PezziConfezione"
        :ScontoLogistico="this.articolo.ScontoLogistico"
    />
</template>
<script>
import CartService from '@/services/cart.service.js';
import AddCartResponse from '@/models/AddCartResponse.model.js';
import {priceMixin, valutaMixin, risorseMixin} from "@/mixin.js";
import ModalScontiLogistici from "@/components/modals/ModalScontiLogistici.vue";

const baseUrl = process.env.VUE_APP_BASEMEDIA_URL;

export default {
    name: "BackorderCartRow",
    props: {
        articolo: Object
    },
    components:{
        ModalScontiLogistici
    },
    emits:['UpdateCart'],
    data(){
        return {
            quantita: 0,
            isLoading: false,
            showModal: false
        }
    },
    computed:{
        urlImmagineArticoloFull: function(){
            return baseUrl + this.articolo.UrlImmagine;
        },
        qtaMultiplo: function(){
            return !((this.articolo.PezziConfezione > 1) && (this.quantita) &&(this.quantita % this.articolo.PezziConfezione == 0));
        },
        HaScontoLogistico: function(){
            return (this.articolo != null && this.articolo.PezziConfezione != null && this.articolo.PezziConfezione != undefined) && (this.articolo != null && this.articolo.ScontoLogistico != null && this.articolo.ScontoLogistico != undefined) && this.articolo.PezziConfezione > 0 && this.articolo.ScontoLogistico > 0;
        }
    },
    watch:{
        articolo: function(newValue){
            this.quantita = newValue.Quantita;
        }
    },
    methods:{
        getCart: function(){
            CartService.getCartByUsername(this.$store.getters.getToken).then(
                (data) => {
                    if(data){
                        let responseCart = new AddCartResponse();
                        Object.assign(responseCart, data);
                        if(responseCart.Status == 1){
                            this.$store.commit('resetCarrelloTmp');
                            this.$store.commit('updateCarrello', responseCart.Carrello);
                            this.$store.commit('setChkSeasonalOrders',(responseCart.Carrello?.ChkSeasonalOrder ?? false));
                            this.$emit("UpdateCart")
                        }
                    }
                }
            );
        },
        addCartRow: function(){
            this.isLoading = true;
            this.$store.dispatch({
                type: 'updateCartRow',
                token: this.$store.getters.getToken,
                idCarrello: this.$store.getters.getCarrello.Testata.IdCarrello,
                codiceArticolo: this.articolo.CodiceArticolo,
                quantita: this.quantita,
                isBackorder: 1
            }).then(
                data => {
                    this.getCart()
                    this.isLoading = false;
                }
            );
        },
        deleteRowCart(){
            this.isLoading = true;
            this.$store.dispatch({
                type: 'deleteCartRow',
                token: this.$store.getters.getToken,
                idCarrello: this.$store.getters.getCarrello.Testata.IdCarrello,
                codiceArticolo: this.articolo.CodiceArticolo,
                isBackorder: 1
            }).then(
                data => {
                    this.getCart();
                    this.isLoading = false;
                }
            );
        },
        OpenModal: function(){
            this.showModal = !this.showModal;
        },
        getSubTotal(){
            return this.articolo?.PrezzoAgente * this.articolo?.Quantita;
        },
        getSubTotalSconto(){
            return this.articolo?.PrezzoTotale;
        },
    },
    mounted: function(){
        this.quantita = this.articolo.Quantita;
    },
    mixins: [priceMixin, valutaMixin, risorseMixin]
}
</script>